// App.js
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import VideoDisplay from "../../components/VideoDisplay/VideoDisplay";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import classes from "./History.module.css";

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: "#f7f7f7",
}));

function History() {
  const [dense, setDense] = React.useState(false);
  const [data, setData] = React.useState();
  const [selectedItem, setSelectedItem] = useState();

  const fetchPost = async () => {
    await getDocs(collection(db, "todos")).then((querySnapshot) => {
      const newData = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setData(newData);
      console.log(newData);
    });
  };

  useEffect(() => {
    fetchPost();
  }, []);

  const onItemClick = (el) => {
    setSelectedItem(el);
  };
  return (
    <div className={classes.container}>
      <div>
        <Box
          sx={{
            flexGrow: 1,
            maxWidth: 752,
            justifyContent: "center",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "20px",
          }}
        >
          <Demo>
            <List>
              {data?.map((el, i) => (
                <div key={i}>
                  <ListItem
                    onClick={() => onItemClick(el)}
                    sx={{ cursor: "pointer" }}
                  >
                    <ListItemText primary={el.input} secondary={el.duration} />
                  </ListItem>
                  <Divider />
                </div>
              ))}
            </List>
          </Demo>
        </Box>
      </div>
      {selectedItem && (
        <div>
          <div>
            <h2>Response</h2>
            <p>{selectedItem.Prompt}</p>
          </div>
          <div>
            <VideoDisplay mediaStream={selectedItem.link} />
          </div>
        </div>
      )}
    </div>
  );
}

export default History;
